import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import StatusPledge from "../../StatusPledge";
import Pagination from "../../../../partials/content/Pagination";
import statusGiftRegisterUser from "./status";

export default function All() {
  const [giftRegisterUser, setGiftRegisterUser] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [amountFilter, setAmountFilter] = useState();

  useEffect(() => {
    getAllGiftRegisterUser();
  }, [currentPage, countItemPerPage, amountFilter]);

  const getAllGiftRegisterUser = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllGiftRegisterUser =
      await sendRequestGetAllGiftRegisterUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllGiftRegisterUser) {
      return;
    }

    setGiftRegisterUser(resultSendRequestGetAllGiftRegisterUser.gifts);
    setCountPage(resultSendRequestGetAllGiftRegisterUser.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (amountFilter) {
      searchFilterQuery = `${searchFilterQuery}&amount=${amountFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllGiftRegisterUser = async (searchFilterQuery) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/gift-user-register/manage?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const changeStatusGift = async (giftID, giftStatus) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllGiftRegisterUser =
      await sendRequestEditGiftRegisterUser(giftID, giftStatus);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllGiftRegisterUser) {
      return;
    }
    getAllGiftRegisterUser();
  };

  const sendRequestEditGiftRegisterUser = async (giftID, giftStatus) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/gift-user-register/manage/${giftID}/active/${giftStatus}`,
        {},
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const generateGetAllGiftRegisterUser = () => {
    return (
      <>
        <div class="container-fluid py-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در مبلغ (تومان)</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="مبلغ را در اینجا وارد کنید"
                  onWheel={(event) => event.currentTarget.blur()}
                  onKeyUp={(e) => setAmountFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive ">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>شماره هدیه</td>
                <td>مبلغ (تومان) </td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>فعال</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {giftRegisterUser.map((item) => {
                return (
                  <tr>
                    <td>{item.gru_id}</td>
                    <td>
                      <span className="letter-spacing-finance-number">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(item.gru_amount)
                        )}
                      </span>
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          item.gru_start_date.split(" ")[0]
                        ) +
                          " " +
                          item.gru_start_date.split(" ")[1]
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          item.gru_end_date.split(" ")[0]
                        ) +
                          " " +
                          item.gru_end_date.split(" ")[1]
                      )}
                    </td>
                    <td>
                      {
                        <span
                          className={`badge  ${
                            item.gru_active ===
                            statusGiftRegisterUser.statusGiftRegisterUser
                              .DISABLE
                              ? "badge-danger"
                              : ""
                          }  ${
                            item.gru_active ===
                            statusGiftRegisterUser.statusGiftRegisterUser.ENABLE
                              ? "badge-success"
                              : ""
                          } 
                       `}
                        >
                          {
                            statusGiftRegisterUser.getLabelGiftRegisterUser()[
                              item.gru_active
                            ]
                          }
                        </span>
                      }
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          item.gru_created_at.split(" ")[0]
                        ) +
                          " " +
                          item.gru_created_at.split(" ")[1]
                      )}{" "}
                    </td>
                    <td>
                      <span className="pl-2">
                        <Link
                          to={
                            "/finance/manage/gift-register-user/edit/" +
                            item.gru_id
                          }
                          className="btn btn-success"
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                      </span>
                      <span className="pl-2">
                        <Link
                          to={
                            "/finance/manage/gift-register-user/list-uses/" +
                            item.gru_id
                          }
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                      <span
                        className={`btn 
                      ${
                        item.gru_active ===
                        statusGiftRegisterUser.statusGiftRegisterUser.ENABLE
                          ? "btn-danger"
                          : ""
                      }
                        ${
                          item.gru_active ===
                          statusGiftRegisterUser.statusGiftRegisterUser.DISABLE
                            ? "btn-primary"
                            : ""
                        }`}
                        title={item.gru_active ? "غیرفعال کردن" : "فعال کردن"}
                        onClick={() => {
                          changeStatusGift(
                            item.gru_id,
                            !item.gru_active ? 1 : 0
                          );
                        }}
                      >
                        <i
                          className={` 
          ${
            item.gru_active ===
            statusGiftRegisterUser.statusGiftRegisterUser.ENABLE
              ? "fa fa-power-off"
              : ""
          }
            ${
              item.gru_active ===
              statusGiftRegisterUser.statusGiftRegisterUser.DISABLE
                ? "fas fa-play"
                : ""
            }

            `}
                        ></i>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="gift-register-user" />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  لیست هدایای ثبت نام کاربران
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <span className="pl-2">
                <Link
                  className="btn btn-info"
                  to="/finance/manage/gift-register-user/add"
                >
                  <span className="pl-2">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>اضافه کردن هدیه</span>
                </Link>
              </span>
              {giftRegisterUser.length == 0 && amountFilter == null ? (
                <></>
              ) : (
                generateGetAllGiftRegisterUser()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
